import http from 'plugins/axios';

export default {
  getAuditList(data) {
    return http.get({
      url: '/la/admin/transfer/frozen/list',
      data
    });
  },
  setPass(data) {
    return http.post({
      url: '/la/admin/transfer/frozen/review',
      data,
      dataType: 'form'
    });
  }
};
